import { render, staticRenderFns } from "./receiveVip.vue?vue&type=template&id=6085a525&scoped=true&"
import script from "./receiveVip.vue?vue&type=script&lang=js&"
export * from "./receiveVip.vue?vue&type=script&lang=js&"
import style0 from "./receiveVip.vue?vue&type=style&index=0&id=6085a525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085a525",
  null
  
)

export default component.exports